"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=fetch-hook-options.js.map